/**
 * TanStack Router: /performance/avaliacoes/form
 *
 * This route file was auto-generated by the route generation script.
 * Component: PerformanceAvaliacoesFormPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import PerformanceAvaliacoesFormPage from '@/app/performance/avaliacoes/form/page'

/**
 * Route: /performance/avaliacoes/form
 * Layout: _auth (authenticated)
 * Component: PerformanceAvaliacoesFormPage
 */
export const Route = createFileRoute('/_auth/performance/avaliacoes/form')({
  component: PerformanceAvaliacoesFormPage,
})
